import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { SignIn, ArrowClockwise } from "@phosphor-icons/react";

const fmt = (iso) => new Date(iso).toLocaleString("de-DE");

export const LoginLogCard = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try { setLogs((await api.get("/auth/login-logs")).data); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="msb-card" data-testid="login-log-card">
      <div className="flex items-center gap-3 mb-3">
        <SignIn size={22} weight="duotone" className="text-primary" />
        <h2 className="text-xl font-bold flex-1" style={{ fontFamily: "'Work Sans',sans-serif" }}>Login-Protokoll</h2>
        <Button variant="outline" size="sm" onClick={load} disabled={loading} data-testid="login-log-refresh-btn">
          <ArrowClockwise size={16} className="mr-1" /> Aktualisieren
        </Button>
      </div>
      <p className="text-sm text-muted-foreground mb-3">Alle Anmeldeversuche (erfolgreich und fehlgeschlagen) mit Zeit, IP-Adresse und Konto.</p>
      <div className="overflow-auto max-h-[480px] max-w-[calc(100vw-6rem)] md:max-w-full">
        <table className="w-full text-sm" data-testid="login-log-table">
          <thead className="text-left text-muted-foreground sticky top-0 bg-background">
            <tr><th className="py-2 pr-3">Zeit</th><th className="pr-3">Konto</th><th className="pr-3">IP-Adresse</th><th className="pr-3">Status</th><th>Gerät</th></tr>
          </thead>
          <tbody>
            {logs.map((l) => (
              <tr key={l.id} className="border-t" data-testid={`login-log-row-${l.id}`}>
                <td className="py-2 pr-3 whitespace-nowrap">{fmt(l.at)}</td>
                <td className="pr-3">{l.email}</td>
                <td className="pr-3 font-mono">{l.ip}</td>
                <td className="pr-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs ${!l.success ? "bg-red-100 text-red-800" : l.stage === "passwort" ? "bg-amber-100 text-amber-800" : "bg-green-100 text-green-800"}`}>
                    {!l.success ? "Fehlgeschlagen" : l.stage === "passwort" ? "Passwort OK" : "Angemeldet"}
                  </span>
                  {l.stage && <span className="ml-1 text-xs text-muted-foreground">({l.stage === "2fa" ? "2FA-Code" : "Passwort"})</span>}
                </td>
                <td className="text-xs text-muted-foreground truncate max-w-[260px]" title={l.user_agent}>{l.user_agent}</td>
              </tr>
            ))}
            {!logs.length && !loading && (
              <tr><td colSpan={5} className="py-4 text-muted-foreground" data-testid="login-log-empty">Noch keine Anmeldungen protokolliert.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
